export default __webpack_public_path__ + "static/media/Phone.8ef01af9.svg";